import { Injectable } from '@angular/core';
import { EntityType } from '@app/shared/enums/entity-type.enum';
import { ApiService } from './api.service';

@Injectable()
export class RoleService extends ApiService {
    entityType = EntityType.ROLE;
    url = 'api/roles/';
}
